import { apiClient } from './client';
import type { PublicStoreTrackingDto } from './generated';

/**
 * Public store tracking identifiers (Meta Pixel, GA4, Google Ads) for the widget.
 */
export async function getStoreTracking(
  storeDomain: string
): Promise<PublicStoreTrackingDto> {
  const response = await apiClient.get<PublicStoreTrackingDto>(
    `/v1/public/stores/${storeDomain}/tracking`
  );
  return response.data;
}
